import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";
import {
  HazardWetlandsLayerType,
  HazardFloodingLayerType,
  HazardFloodingSummaryLayerType,
  HazardWetlandsSummaryLayerType,
} from "../layer_types/HazardLayerType";

export const HAZARDS: Layer = {
  id: ConstraintsCategory.HAZARDS,
  layerType: ConstraintsLayerType,
  hideByDefault: true,
  title: "Hazards",
  requiredFeatureAccess: [Feature.hazardsLayer],
  toggleable: true,
  group: LayerGroup.ENVIRONMENTAL,
  icon: "lt-alert-line",
  description: "Flood zones and wetlands",
  layerConfig: {
    rootCategory: ConstraintsCategory.HAZARDS,
    categorySchema: [
      { key: "us_flood_zones_high_risk_1_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_high_risk_coastal_1_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_high_risk_regulatory_floodway" },
      { key: "us_flood_zones_high_risk_coastal_regulatory_floodway" },
      { key: "us_flood_zones_moderate_risk_0_2_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_minimal_risk_future_conditions_1_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_unknown_risk_area_with_risk_due_to_levee" },
      { key: "us_flood_zones_minimal_risk_area_with_reduced_risk_due_to_levee" },
      { key: "us_flood_zones_high_risk_special_floodway" },
      { key: "us_flood_zones_unknown_risk_area_of_undetermined_flood_hazard" },
      { key: "us_flood_zones_other" },
      { key: "us_wetlands_estuarine_and_marine_deepwater" },
      { key: "us_wetlands_estuarine_and_marine_wetland" },
      { key: "us_wetlands_freshwater_emergent_wetland" },
      { key: "us_wetlands_freshwater_forested_shrub_wetland" },
      { key: "us_wetlands_freshwater_pond" },
      { key: "us_wetlands_lake" },
      { key: "us_wetlands_riverine" },
      { key: "us_wetlands_other" },
    ],
  },
  zoomConfig: {
    minVisualisationZoom: 10,
  },
};

export const HAZARDS_FLOODING: Layer = {
  ...HAZARDS,
  id: `${ConstraintsCategory.HAZARDS}--flooding`,
  layerType: HazardFloodingLayerType,
  title: "Flooding",
  description: "Could limit the type of development that can be done, or restrict use",
  layerConfig: {
    rootCategory: ConstraintsCategory.HAZARDS,
    categorySchema: [
      { key: "us_flood_zones_high_risk_1_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_high_risk_coastal_1_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_high_risk_regulatory_floodway" },
      { key: "us_flood_zones_high_risk_coastal_regulatory_floodway" },
      { key: "us_flood_zones_moderate_risk_0_2_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_minimal_risk_future_conditions_1_percent_annual_chance_flood_hazard" },
      { key: "us_flood_zones_unknown_risk_area_with_risk_due_to_levee" },
      { key: "us_flood_zones_minimal_risk_area_with_reduced_risk_due_to_levee" },
      { key: "us_flood_zones_high_risk_special_floodway" },
      { key: "us_flood_zones_unknown_risk_area_of_undetermined_flood_hazard" },
      { key: "us_flood_zones_other" },
    ],
  },
};

export const HAZARDS_FLOODING_SUMMARY: Layer = {
  ...HAZARDS_FLOODING,
  id: `${HAZARDS_FLOODING.id}--summary`,
  layerType: HazardFloodingSummaryLayerType,
  requiredFeatureAccess: [Feature.insightsSummary],
};

export const HAZARDS_WETLANDS: Layer = {
  ...HAZARDS,
  id: `${ConstraintsCategory.HAZARDS}--wetlands`,
  layerType: HazardWetlandsLayerType,
  title: "Wetlands",
  description: "Could limit the type of development that can be done, or restrict use",
  layerConfig: {
    rootCategory: ConstraintsCategory.HAZARDS,
    categorySchema: [
      { key: "us_wetlands_estuarine_and_marine_deepwater" },
      { key: "us_wetlands_estuarine_and_marine_wetland" },
      { key: "us_wetlands_freshwater_emergent_wetland" },
      { key: "us_wetlands_freshwater_forested_shrub_wetland" },
      { key: "us_wetlands_freshwater_pond" },
      { key: "us_wetlands_lake" },
      { key: "us_wetlands_riverine" },
      { key: "us_wetlands_other" },
    ],
  },
};

export const HAZARDS_WETLANDS_SUMMARY: Layer = {
  ...HAZARDS_WETLANDS,
  id: `${HAZARDS_WETLANDS.id}--summary`,
  layerType: HazardWetlandsSummaryLayerType,
  requiredFeatureAccess: [Feature.insightsSummary],
};
